module.exports = __webpack_public_path__ + "img/product_69.93453f2.svg";